import React, { Component } from 'react';
import { connect } from 'react-redux';
import Store from '../../../redux/Store';
import { Lens as CircleIcon } from '@mui/icons-material';
import Constants from '../../../common/constants/Constants';
import DeploymentStateEnum from '../../../common/constants/DeploymentStateEnum';
import Loading from '../../../common/components/Loading/Loading';
import UpdateJobCreator from './UpdateJobCreator';
import { getFleets, getPackages, deployPackage } from './UpdateJobActions';

import { getUpdateJobDetails } from './UpdateJobActions';
import { getInstrumentsListForFleet } from './../../Fleets/components/FleetEditor/FleetEditor.actions';

import { showSnackbar } from '../../../common/state/snackbar/Snackbar.actions';

import PermissionsCheck from '../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../common/constants/PermissionsEnum';
import PageContainer from '../../../common/components/Page/PageContainer';

class UpdateJobCreatorContainer extends Component {
  constructor(props) {
    super();

    this.state = {
      data: [],
      isFetching: false,
      canStartUpdateJob: true,
      selectedPackageId: '',
      selectedFleetId: '',
      fleetList: [],
      packageList: [],
    };

    this.earlyMessages = [];
    this.columnConfigs = [
      {
        name: 'Serial number',
        key: 'SerialNumber',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Type',
        key: 'Type',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Region',
        key: 'RegionName',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Group',
        key: 'GroupName',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Location',
        key: 'Location',
        type: 'string',
        visible: false,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Software version',
        key: 'SoftwareVersion',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Date and time of last update job status',
        key: 'LastUpdateJobDateTime',
        type: 'datetime',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Update job status',
        key: 'UpdateJobStatus',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Error message',
        key: 'ErrorMessage',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Connection alert',
        key: 'ConnectionAlert.Level',
        type: 'markup',
        markup: (el, col, elIndex, colIndex) => {
          var style = {
            width: '.75rem',
            height: '.75rem',
            marginTop: '5px',
            color: el.ConnectionAlert ? el.ConnectionAlert.Color : Constants.COLORS.NEUTRAL,
          };
          return <CircleIcon key={1} style={style} fill={style.color} />;
        },
        visible: true,
        filterable: true,
        sortable: true,
      },
    ];
  }

  componentDidMount() {
    let fleetList = null;
    let packageList = null;

    Promise.all([getFleets(), getPackages()])
      .then(([resFleets, resPackages]) => {
        fleetList = resFleets.body;
        packageList = resPackages.body;
        this.setState({ fleetList, packageList, isFetching: false });
      })
      .catch((err) => this.setState({ isFetching: false }));
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(prevProps.packageDeploymentMessage) !==
      JSON.stringify(this.props.packageDeploymentMessage)
    ) {
      this._handlePackageDeploymentMessage(this.props.packageDeploymentMessage);
    } else if (
      JSON.stringify(prevProps.transferProgressMessage) !=
      JSON.stringify(this.props.transferProgressMessage)
    ) {
      this._handleTransferProgressMessage(this.props.transferProgressMessage);
    }
  }

  render() {
    return (
      <PageContainer pageName="update-job-creator">
        <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.CREATE_UPDATE_JOBS}>
          <Loading condition={this.state.isFetching}>
            <div>
              <UpdateJobCreator
                availablePackages={this._sortByName(this.state.packageList)}
                fleets={this._sortByName(this.state.fleetList)}
                selectedPackageId={this.state.selectedPackageId}
                selectedFleetId={this.state.selectedFleetId}
                onSelectPackage={this._onSelectPackageCallback}
                onSelectFleet={this._onSelectFleetCallback}
                startUpdateJob={this._startUpdateJob}
                startUpdateJobDisabled={!this._validateRequiredSelection()}
                columns={this.columnConfigs}
                data={this.state.data}
              />
            </div>
          </Loading>
        </PermissionsCheck>
      </PageContainer>
    );
  }

  _sortByName = (array) => {
    return array.sort((a, b) => a.Name.localeCompare(b.Name));
  };

  _handlePackageDeploymentMessage = (message) => {
    const { CommandGuid, DeploymentState, ErrorMessage, DeploymentStateTime } = JSON.parse(
      message.data
    );

    let newData = Object.assign([], this.state.data);
    const elIndex = newData.findIndex((el) => el.MessageCommandGuid === CommandGuid);

    if (elIndex === -1) {
      this.earlyMessages.push(message);
      return;
    }

    newData[elIndex] = {
      ...newData[elIndex],
      UpdateJobStatus: DeploymentStateEnum.GetStateName(DeploymentState),
      ErrorMessage: ErrorMessage,
      LastUpdateJobDateTime: DeploymentStateTime,
    };
    this.setState({ data: newData });
  };

  _retrieveEarlierMessages = () => {
    if (this.earlyMessages.length > 0) {
      this.earlyMessages.forEach((message) => this._handlePackageDeploymentMessage(message));
      this.earlyMessages = [];
    }
  };

  _handleTransferProgressMessage = (message) => {
    const { CommandGuid, FileSize, BytesTransferred, Status } = JSON.parse(message.data);
    let newData = Object.assign([], this.state.data);
    let elIndex = newData.findIndex((el) => el.MessageCommandGuid === CommandGuid);
    if (elIndex === -1) return;
    const percentage = Math.round((BytesTransferred / FileSize) * 100);
    const labeledStatus = Status + ' ' + percentage + '%';

    newData[elIndex] = {
      ...newData[elIndex],
      UpdateJobStatus: labeledStatus,
    };
    this.setState({ data: newData });
  };

  _onSelectPackageCallback = (value) => {
    this.setState({
      selectedPackageId: value,
    });
  };

  _onSelectFleetCallback = (value) => {
    getInstrumentsListForFleet(value)
      .then((res) => {
        // Initialize properties, since the response doesn't contain it (see PackageDeploymentManager.GetUpdateJobDetails)
        let instrumentList = res.body.Data.map((i) => ({
          ...i,
          MessageCommandGuid: '',
          UpdateJobStatus: DeploymentStateEnum.GetStateName(DeploymentStateEnum.NONE),
          LastUpdateJobDateTime: null,
          ErrorMessage: '',
          Error: false,
        }));
        this.setState({ selectedFleetId: value, data: instrumentList });
      })
      .catch((err) => {});
  };

  _startUpdateJob = () => {
    this.setState({ canStartUpdateJob: false });
    let createdJobId = null;

    deployPackage(this.state.selectedPackageId, this.state.selectedFleetId)
      .then((res) => {
        createdJobId = res.body.PackageDeploymentJobId;
        this.setState({ canStartUpdateJob: true });
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
            message: 'Update job successfully started.',
          })
        );
      })
      .then(() => this._getDeployments(createdJobId))
      .catch((err) => {
        this.setState({ canStartUpdateJob: true });
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed to start update job.',
          })
        );
      });
  };

  _validateRequiredSelection = () => {
    if (
      this.state.selectedFleetId &&
      this.state.selectedPackageId &&
      this.state.canStartUpdateJob &&
      this.state.data.length > 0
    ) {
      return true;
    }
    return false;
  };

  _getDeployments = (createdJobId) => {
    getUpdateJobDetails(createdJobId)
      .then((res) => {
        let newData = res.body;
        newData.forEach(
          (n) => (n.UpdateJobStatus = DeploymentStateEnum.GetStateName(n.UpdateJobStatus))
        );
        const mergedData = Object.assign(this.state.data, newData);
        this.setState({
          data: mergedData,
          isFetching: false,
        });
        this._retrieveEarlierMessages();
      })
      .catch((err) => this.setState({ isFetching: false }));
  };
}

const mapStateToProps = (state) => ({
  packageDeploymentMessage:
    state.push.pushMessages != null
      ? state.push.pushMessages.find((el) => el.type === 'PackageDeploymentFeedback')
      : null,
  transferProgressMessage:
    state.push.pushMessages != null
      ? state.push.pushMessages.find((el) => el.type === 'FileTransferProgress')
      : null,
});

export default connect(mapStateToProps)(UpdateJobCreatorContainer);
